import {
  Box,
  Button,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";

import { IconAddressBook, IconUser, IconUserCircle } from "@tabler/icons";

const Profile = ({ user }) => {
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [copied, setCopied] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  return (
    <Box>
      <IconButton
        size="large"
        aria-label="User Profile Icon"
        color="inherit"
        aria-controls="msgs-menu"
        aria-haspopup="true"
        sx={{
          ...(typeof anchorEl2 === "object" && {
            color: "earnpati.main",
          }),
        }}
        onClick={handleClick2}
      >
        <IconUserCircle width={35} height={35} />
      </IconButton>
      {/* ------------------------------------------- */}
      {/* Message Dropdown */}
      {/* ------------------------------------------- */}
      <Menu
        id="msgs-menu"
        anchorEl={anchorEl2}
        keepMounted
        open={Boolean(anchorEl2)}
        onClose={handleClose2}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        sx={{
          "& .MuiMenu-paper": {
            width: "200px",
          },
        }}
      >
        <MenuItem onClick={() => (window.location.href = "/dashboard")}>
          <ListItemIcon>
            <IconUser width={20} />
          </ListItemIcon>
          <ListItemText>{user?.name}</ListItemText>
        </MenuItem>
        <MenuItem>
          <ListItemText sx={{ textAlign: "center", color: "grey" }}>
            {user?.user_id}
            <Button
              variant="outlined"
              sx={{
                minWidth: "50px",
                padding: 0,
                marginLeft: "15px",
              }}
              onClick={() => navigator.clipboard.writeText(user?.user_id)}
            >
              Copy
            </Button>
          </ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => (window.location.href = "/profile")}>
          <ListItemIcon>
            <IconAddressBook width={20} />
          </ListItemIcon>
          <ListItemText>My Profile</ListItemText>
        </MenuItem>
        {user?.role && user?.role.includes("admin") ? (
          <Box mt={1} py={1} px={2}>
            <Button
              to="/admin"
              variant="outlined"
              color="primary"
              component={Link}
              fullWidth
            >
              Admin
            </Button>
          </Box>
        ) : null}
        <Box mt={1} py={1} px={2}>
          <Button
            to="/auth/login"
            variant="outlined"
            color="primary"
            component={Link}
            onClick={() => {
              localStorage.removeItem("token");
              localStorage.removeItem("refresh");
              localStorage.removeItem("store");
            }}
            fullWidth
          >
            Logout
          </Button>
        </Box>
      </Menu>
    </Box>
  );
};

export default Profile;
